export function onChangeWithLimits(event, callback) {
  const value = Number(event.target.value);
  let min = event.target.getAttribute("min");
  const max = event.target.getAttribute("max");
  if ((!min || !value || value >= min) && (!max || value <= max)) {
    callback(value);
  }
}
